var EARLY_ACCESS_SUBDOMAIN = '__next';
var OPTIMIZELY_OVERRIDE = 'optimizely_feature_override:';
var OPTIMIZELY_ENVIRONMENT_STORAGE_KEY = 'optimizely_feature_toggle_environment';
var FEATURE_TOGGLE_ENVIRONMENT_QUERY_KEY = 'feature_toggle_environment';
var OPTIMIZELY_ENVIRONMENT_MAP = {
  production: '2',
  staging: '1',
  dev: '0'
};
export { EARLY_ACCESS_SUBDOMAIN, OPTIMIZELY_OVERRIDE, OPTIMIZELY_ENVIRONMENT_STORAGE_KEY, FEATURE_TOGGLE_ENVIRONMENT_QUERY_KEY, OPTIMIZELY_ENVIRONMENT_MAP };